export function generateBadgingReport(badgeData, students) {
  const badgesByStudentId = {}
  for (const badge of badgeData) {
    const {studentId} = badge;
    if (!(studentId in badgesByStudentId)) badgesByStudentId[studentId] = []
    badgesByStudentId[studentId].push(badge);
  }

  const report = []
  for (const student of students) {
    const {id, first_name, last_name} = student;
    let earnedCount = 0;
    const badgesByType = {}
    const badges = badgesByStudentId[id] || []
    for (const badge of badges) {
      const { awarded, badgeTypeId } = badge;
      if (awarded) earnedCount++;
      if (!(badgeTypeId in badgesByType)) badgesByType[badgeTypeId] = [];
      badgesByType[badgeTypeId].push(badge);
    }

    report.push({
      studentId: id,
      firstName: first_name,
      lastName: last_name,
      earnedCount,
      badges: badgesByType,
    })
  }

  return report;
}